/**
 * <WildQuestLogo />
 *
 * Single source of truth for the official WildQuest brand mark.
 * Uses the PNG shipped in /public so every touch-point — login
 * badge, app-shell header, share cards, PDF exports (via URL) —
 * displays the same globe-with-wildlife identity.
 *
 * Sizing is controlled via className so callers can drop it into
 * chips, hero blocks, or headers without wrapper divs.
 */
export const WildQuestLogo = ({
  className = 'w-6 h-6',
  alt = 'WildQuest',
  ...rest
}) => (
  <img
    src="/wildquest-logo.png"
    alt={alt}
    data-testid="wildquest-logo"
    className={`object-contain ${className}`}
    loading="eager"
    decoding="async"
    {...rest}
  />
);

export default WildQuestLogo;
